import produce from 'immer'
import { mapOrder } from 'services/utilities'
import { actions } from './actions'

const initialState = {
  urls: {
    data: [],
    loading: false,
    error: '',
  },
  urlsCartel: {
    data: [],
    loading: false,
    error: '',
    reload: false,
  },
  url: {
    data: null,
    loading: false,
    error: '',
  },
  urlsAsociadasUrlGrupo: {
    data: [],
    loading: false,
    error: '',
    reload: false,
  },
  urlsAdicionales: {
    data: [],
    loading: false,
    error: '',
    reload: false,
  },
  urlsFotos: {
    data: [],
    loading: false,
    error: '',
    reload: false,
  },
  urlHistorialPosicion: {
    data: [],
    loading: false,
    error: '',
    reload: false,
  },
}

export default function urlReducer(state = initialState, action) {
  switch (action.type) {
    case actions.URLS_LOAD_REQUESTED:
      return { ...state, urls: { ...state.urls, loading: true } }
    case actions.URLS_LOAD_FILTERED_REQUESTED:
      return { ...state, urls: { ...state.urls, loading: true } }
    case actions.URLS_LOAD_SUCCEEDED:
      return { ...state, urls: { ...state.urls, data: action.payload, loading: false } }
    case actions.URLS_LOAD_FILED:
      return { ...state, urls: { ...state.urls, loading: false, error: action.error } }

    case actions.URLS_DELETED_LOAD_REQUESTED:
      return { ...state, urls: { ...state.urls, loading: true } }
    case actions.URLS_DELETED_LOAD_SUCCEEDED:
      return { ...state, urls: { ...state.urls, data: action.payload, loading: false } }
    case actions.URLS_DELETED_LOAD_FAILED:
      return { ...state, urls: { ...state.urls, loading: false, error: action.error } }

    case actions.URL_BYID_LOAD_REQUESTED:
      return {
        ...state,
        url: { ...state.url, loading: true, error: '' },
      }
    case actions.URL_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        url: { ...state.url, data: action.payload, loading: false, error: '' },
      }
    case actions.URL_BYID_LOAD_FILED:
      return {
        ...state,
        url: { ...state.url, data: null, loading: false, error: action.error },
      }
    case actions.URL_BYID_LOAD_INSERT_REQUESTED:
      return {
        ...state,
        url: { ...state.url, data: null, loading: false, error: '' },
      }
    case actions.URL_UPDATE_REQUESTED:
      return {
        ...state,
        url: { ...state.url, loading: true, error: '' },
      }
    case actions.URL_UPDATE_SUCCEEDED:
      return {
        ...state,
        url: { ...state.url, data: action.payload, loading: false, error: '' },
      }
    case actions.URL_UPDATE_FILED:
      return {
        ...state,
        url: { ...state.url, loading: false, error: action.error },
      }
    case actions.URL_INSERT_REQUESTED:
      return {
        ...state,
        url: { ...state.url, loading: true, error: '' },
      }
    case actions.URL_INSERT_SUCCEEDED:
      return {
        ...state,
        url: { ...state.url, data: action.payload, loading: false, error: '' },
      }
    case actions.URL_INSERT_FILED:
      return {
        ...state,
        url: { ...state.url, loading: false, error: action.error },
      }
    case actions.URL_DELETE_REQUESTED:
      return {
        ...state,
        urls: { ...state.urls, loading: true, error: '' },
      }
    case actions.URL_DELETE_SUCCEEDED:
      return {
        ...state,
        urls: {
          ...state.urls,
          data: state.urls.data.filter(url => url.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.URL_DELETE_FILED:
      return {
        ...state,
        urls: { ...state.urls, loading: false, error: action.error },
      }
    case actions.URLS_DELETE_REQUESTED:
      return {
        ...state,
        urls: { ...state.urls, loading: true, error: '' },
      }
    case actions.URLS_DELETE_SUCCEEDED:
      return {
        ...state,
        urls: {
          ...state.urls,
          data: state.urls.data.filter(url => !action.payload.urlIds.includes(url.id)),
          loading: false,
          error: '',
        },
      }
    case actions.URLS_DELETE_FILED:
      return {
        ...state,
        urls: { ...state.urls, loading: false, error: action.error },
      }
    case actions.URLS_LOAD_BY_CATEGORIA_REQUESTED:
      return { ...state, urls: { ...state.urls, loading: true } }
    case actions.URLS_LOAD_BY_CATEGORIA_SUCCEEDED:
      return { ...state, urls: { ...state.urls, data: action.payload, loading: false } }
    case actions.URLS_LOAD_BY_CATEGORIA_FILED:
      return { ...state, urls: { ...state.urls, loading: false, error: action.error } }

    case actions.URLS_BY_CARTEL_ID_LOAD_REQUESTED:
      return { ...state, urlsCartel: { ...state.urlsCartel, loading: true } }
    case actions.URLS_BY_CARTEL_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        urlsCartel: { ...state.urlsCartel, data: action.payload, loading: false, reload: false },
      }
    case actions.URLS_BY_CARTEL_ID_LOAD_FILED:
      return { ...state, urlsCartel: { ...state.urlsCartel, loading: false, error: action.error } }

    case actions.URLS_BY_CARTEL_ID_REDUCED_LOAD_REQUESTED:
      return { ...state, urlsCartel: { ...state.urlsCartel, loading: true } }
    case actions.URLS_BY_CARTEL_ID_REDUCED_LOAD_SUCCEEDED:
      return {
        ...state,
        urlsCartel: { ...state.urlsCartel, data: action.payload, loading: false, reload: false },
      }
    case actions.URLS_BY_CARTEL_ID_REDUCED_LOAD_FILED:
      return { ...state, urlsCartel: { ...state.urlsCartel, loading: false, error: action.error } }

    case actions.URL_CARTEL_UPDATE_REQUESTED:
      return { ...state, urlsCartel: { ...state.urlsCartel, loading: true } }
    case actions.URL_CARTEL_UPDATE_SUCCEEDED:
      return { ...state, urlsCartel: { ...state.urlsCartel, reload: true, loading: false } }
    case actions.URL_CARTEL_UPDATE_FILED:
      return { ...state, urlsCartel: { ...state.urlsCartel, loading: false, error: action.error } }

    case actions.URLS_BY_URL_GRUPO_ID_LOAD_REQUESTED:
      return { ...state, urlsAsociadasUrlGrupo: { ...state.urlsAsociadasUrlGrupo, loading: true } }
    case actions.URLS_BY_URL_GRUPO_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        urlsAsociadasUrlGrupo: {
          ...state.urlsAsociadasUrlGrupo,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.URLS_BY_URL_GRUPO_ID_LOAD_FILED:
      return {
        ...state,
        urlsAsociadasUrlGrupo: {
          ...state.urlsAsociadasUrlGrupo,
          loading: false,
          error: action.error,
        },
      }
    case actions.URLS_LOAD_BY_CATEGORIA_WITH_URL_GRUPO_REQUESTED:
      return {
        ...state,
        urls: { ...state.urls, data: null, loading: true, error: '' },
      }
    case actions.URLS_LOAD_BY_CATEGORIA_WITH_URL_GRUPO_SUCCEEDED:
      return {
        ...state,
        urls: { ...state.urls, data: action.payload, loading: false, error: '' },
      }
    case actions.URLS_LOAD_BY_CATEGORIA_WITH_URL_GRUPO_FILED:
      return {
        ...state,
        urls: { ...state.urls, data: null, loading: false, error: action.error },
      }
    case actions.URL_GRUPO_ASOCIACION_DELETE_REQUESTED:
      return { ...state, urlsAsociadasUrlGrupo: { ...state.urlsAsociadasUrlGrupo, loading: true } }
    case actions.URL_GRUPO_ASOCIACION_DELETE_SUCCEEDED:
      return {
        ...state,
        urlsAsociadasUrlGrupo: {
          ...state.urlsAsociadasUrlGrupo,
          data: state.urlsAsociadasUrlGrupo.data.filter(url => url.id !== action.payload),
          loading: false,
        },
      }
    case actions.URL_GRUPO_ASOCIACION_DELETE_FILED:
      return {
        ...state,
        urlsAsociadasUrlGrupo: {
          ...state.urlsAsociadasUrlGrupo,
          loading: false,
          error: action.error,
        },
      }
    case actions.URL_GRUPO_ASOCIACION_URL_REQUESTED:
      return { ...state, urlsAsociadasUrlGrupo: { ...state.urlsAsociadasUrlGrupo, loading: true } }
    case actions.URL_GRUPO_ASOCIACION_URL_SUCCEEDED:
      return {
        ...state,
        urlsAsociadasUrlGrupo: { ...state.urlsAsociadasUrlGrupo, reload: true, loading: false },
      }
    case actions.URL_GRUPO_ASOCIACION_URL_FILED:
      return {
        ...state,
        urlsAsociadasUrlGrupo: {
          ...state.urlsAsociadasUrlGrupo,
          reload: false,
          loading: false,
          error: action.error,
        },
      }
    case actions.CLEAR_URLS_GRUPOS_REQUESTED:
      return {
        ...state,
        urlsAsociadasUrlGrupo: {
          ...state.urlsAsociadasUrlGrupo,
          data: [],
          loading: false,
          error: action.error,
        },
      }
    case actions.URLS_ADICIONALES_LOAD_REQUESTED:
      return { ...state, urlsAdicionales: { ...state.urlsAdicionales, loading: true } }
    case actions.URLS_ADICIONALES_LOAD_SUCCEEDED:
      return {
        ...state,
        urlsAdicionales: { ...state.urlsAdicionales, data: action.payload, loading: false },
      }
    case actions.URLS_ADICIONALES_LOAD_FILED:
      return {
        ...state,
        urlsAdicionales: { ...state.urlsAdicionales, loading: false, error: action.error },
      }
    case actions.URLS_ADICIONALES_UPDATE_REQUESTED:
      return {
        ...state,
        urlsAdicionales: { ...state.urlsAdicionales, loading: true, error: '' },
      }
    case actions.URLS_ADICIONALES_UPDATE_SUCCEEDED:
      return {
        ...state,
        urlsAdicionales: { ...state.urlsAdicionales, loading: false, error: '' },
      }
    case actions.URLS_ADICIONALES_UPDATE_FILED:
      return {
        ...state,
        urlsAdicionales: { ...state.urlsAdicionales, loading: false, error: action.error },
      }
    case actions.URLS_IMAGENES_RELACIONADAS_BY_URL_ID_LOAD_REQUESTED:
      return {
        ...state,
        urlsImagenesRelacionadas: { ...state.urlsImagenesRelacionadas, loading: true },
      }
    case actions.URLS_IMAGENES_RELACIONADAS_BY_URL_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        urlsImagenesRelacionadas: {
          ...state.urlsImagenesRelacionadas,
          data: action.payload,
          loading: false,
        },
      }
    case actions.URLS_IMAGENES_RELACIONADAS_BY_URL_ID_LOAD_FILED:
      return {
        ...state,
        urlsImagenesRelacionadas: {
          ...state.urlsImagenesRelacionadas,
          loading: false,
          error: action.error,
        },
      }

    case actions.URLS_IMAGENES_RELACIONADAS_DELETE_FILED:
      return {
        ...state,
        urlsImagenesRelacionadas: {
          ...state.urlsImagenesRelacionadas,
          loading: false,
          error: action.error,
        },
      }
    case actions.URLS_IMAGENES_RELACIONADAS_INSERT_REQUESTED:
      return {
        ...state,
        urlsImagenesRelacionadas: { ...state.urlsImagenesRelacionadas, loading: true, error: '' },
      }
    case actions.URLS_IMAGENES_RELACIONADAS_INSERT_SUCCEEDED:
      return {
        ...state,
        urlsImagenesRelacionadas: {
          ...state.urlsImagenesRelacionadas,
          data: [].concat(action.payload, state.urlsImagenesRelacionadas.data),
          loading: false,
          error: '',
        },
      }
    case actions.URLS_IMAGENES_RELACIONADAS_INSERT_FILED:
      return {
        ...state,
        urlsImagenesRelacionadas: {
          ...state.urlsImagenesRelacionadas,
          loading: false,
          error: action.error,
        },
      }
    case actions.URLS_VIDEOS_RELACIONADAS_BY_URL_ID_LOAD_REQUESTED:
      return {
        ...state,
        urlsVideosRelacionados: { ...state.urlsVideosRelacionados, loading: true },
      }
    case actions.URLS_VIDEOS_RELACIONADAS_BY_URL_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        urlsVideosRelacionados: {
          ...state.urlsVideosRelacionados,
          data: action.payload,
          loading: false,
        },
      }
    case actions.URLS_VIDEOS_RELACIONADAS_BY_URL_ID_LOAD_FILED:
      return {
        ...state,
        urlsVideosRelacionados: {
          ...state.urlsVideosRelacionados,
          loading: false,
          error: action.error,
        },
      }

    case actions.URLS_VIDEOS_RELACIONADAS_DELETE_REQUESTED:
      return {
        ...state,
        urlsVideosRelacionados: { ...state.urlsVideosRelacionados, loading: true, error: '' },
      }
    case actions.URLS_VIDEOS_RELACIONADAS_DELETE_SUCCEEDED:
      return {
        ...state,
        urlsVideosRelacionados: {
          ...state.urlsVideosRelacionados,
          data: state.urlsVideosRelacionados.data.filter(
            urlImagenRel => urlImagenRel.id !== action.payload,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.URLS_VIDEOS_RELACIONADAS_DELETE_FILED:
      return {
        ...state,
        urlsVideosRelacionados: {
          ...state.urlsVideosRelacionados,
          loading: false,
          error: action.error,
        },
      }

    case actions.URLS_FOTOS_BY_URL_ID_LOAD_REQUESTED:
      return {
        ...state,
        urlsFotos: { ...state.urlsFotos, loading: true },
      }
    case actions.URLS_FOTOS_BY_URL_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        urlsFotos: {
          ...state.urlsFotos,
          data: action.payload,
          loading: false,
        },
      }
    case actions.URLS_FOTOS_BY_URL_ID_LOAD_FILED:
      return {
        ...state,
        urlsFotos: {
          ...state.urlsFotos,
          loading: false,
          error: action.error,
        },
      }
    case actions.URLS_FOTOS_DELETE_REQUESTED:
      return {
        ...state,
        urlsFotos: { ...state.urlsFotos, loading: true, error: '' },
      }
    case actions.URLS_FOTOS_DELETE_SUCCEEDED:
      return {
        ...state,
        urlsFotos: {
          ...state.urlsFotos,
          data: state.urlsFotos.data.filter(urlFoto => urlFoto.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.URLS_FOTOS_DELETE_FILED:
      return {
        ...state,
        urlsFotos: {
          ...state.urlsFotos,
          loading: false,
          error: action.error,
        },
      }
    case actions.URLS_FOTOS_INSERT_REQUESTED:
      return {
        ...state,
        urlsFotos: { ...state.urlsFotos, loading: true, error: '' },
      }
    case actions.URLS_FOTOS_INSERT_SUCCEEDED:
      return {
        ...state,
        urlsFotos: {
          ...state.urlsFotos,
          data: [].concat(action.payload, state.urlsFotos.data),
          loading: false,
          error: '',
        },
      }
    case actions.URLS_FOTOS_INSERT_FILED:
      return {
        ...state,
        urlsFotos: {
          ...state.urlsFotos,
          loading: false,
          error: action.error,
        },
      }
    case actions.URLS_FOTOS_SORT_ITEMS_UPDATE_REQUESTED:
      return {
        ...state,
        urlsFotos: { data: mapOrder(state.urlsFotos.data, action.payload, 'id'), loading: true },
      }
    case actions.URL_FOTO_UPDATED: {
      const urlFotoDto = action.payload
      const newState = produce(state, draftState => {
        const fotos = draftState.urlsFotos.data.map(urlFoto => {
          if (urlFoto.id === urlFotoDto.id) {
            return urlFotoDto
          }
          return urlFoto
        })
        draftState.urlsFotos.data = fotos
      })
      return newState
    }
    case actions.URLS_FOTOS_SORT_ITEMS_UPDATE_SUCCEEDED:
      return {
        ...state,
        urlsFotos: {
          data: mapOrder(state.urlsFotos.data, action.payload, 'id'),
          loading: false,
        },
      }
    case actions.URLS_FOTOS_SORT_ITEMS_UPDATE_FILED:
      return {
        ...state,
        urlsFotos: {
          ...state.urlsFotos,
          loading: false,
          error: action.error,
        },
      }

    case actions.URLS_HISTORIAL_POSICIONES_REQUESTED:
      return { ...state, urlHistorialPosicion: { ...state.urlHistorialPosicion, loading: true } }
    case actions.URLS_HISTORIAL_POSICIONES_SUCCEEDED:
      return {
        ...state,
        urlHistorialPosicion: {
          ...state.urlHistorialPosicion,
          data: action.payload,
          loading: false,
        },
      }
    case actions.URLS_HISTORIAL_POSICIONES_FAILED:
      return {
        ...state,
        urlHistorialPosicion: {
          ...state.urlHistorialPosicion,
          loading: false,
          error: action.error,
        },
      }

    case actions.URL_SET_MOSTRARCANTIDAD_SUCEEDED: {
      const { urlId, mostrarCantidad } = action.payload
      const newState = produce(state, draftState => {
        const url = draftState.urls?.data?.find(u => u.id === urlId)
        if (url) url.mostrarCantidad = mostrarCantidad
      })
      return newState
    }
    case actions.URL_RECUPERAR_URLS_REQUESTED:
      return {
        ...state,
        urls: { ...state.urls, loading: true, error: '' },
      }
    case actions.URL_RECUPERAR_URLS_SUCCEEDED:
      return {
        ...state,
        urls: {
          ...state.urls,
          data: state.urls.data.filter(url => !action.payload.includes(url.id)),
          loading: false,
          error: '',
        },
      }
    case actions.URL_RECUPERAR_URLS_FAILED:
      return {
        ...state,
        urls: { ...state.urls, loading: false, error: action.error },
      }

    default:
      return state
  }
}
